module.exports = __webpack_public_path__ + "img/btlabs.b80ad57d.png";